import React from 'react';

const SupportPage = () => {
  return (
    <div className="bg-[#1e1e1e] text-white rounded-xl p-6 w-full mx-auto">
      <div className="grid grid-cols-3 items-center border-b border-gray-700 py-3">
        <span>For Technical Support</span>
        <span className="text-center">:</span>
        <span className="text-right">Support@patchifi.com</span>
      </div>
      <div className="grid grid-cols-3 items-center border-b border-gray-700 py-3">
        <span>For Sales Support </span>
        <span className="text-center">:</span>
        <span className="text-right">Sales@patchifi.com</span>
      </div>

      <div className="grid grid-cols-3 items-center py-3">
        <span>To Raise a Support Ticket</span>
        <span className="text-center">:</span>
        <span className="text-right">
          <button className="bg-red-600 hover:bg-red-700 text-white text-sm px-4 py-1.5 rounded-full">Raise Ticket</button>
        </span>
      </div>
    </div>
  );
};

export default SupportPage;
